import { getCanonicalLanguage } from "@corca/tiptap";
import { nanoid } from "nanoid";

import { resolveCellGroup } from "@/components/tiptap/CodeBlock";

import type { JSONContent } from "@tiptap/core";
import type { EditorState } from "@tiptap/pm/state";

export function freshCodeBlockRuntimeAttrs(
  attrs: JSONContent["attrs"] | undefined,
  state: EditorState,
) {
  const rawLanguage = typeof attrs?.language === "string" ? attrs.language : undefined;
  const language = rawLanguage ? (getCanonicalLanguage(rawLanguage) ?? rawLanguage) : rawLanguage;
  const rawCellGroup = typeof attrs?.cellGroup === "string" ? attrs.cellGroup : undefined;

  return {
    ...attrs,
    language,
    cellId: nanoid(),
    cellGroup: rawCellGroup || resolveCellGroup(language ?? "", state),
  };
}
